module.exports = __webpack_public_path__ + "img/bottom_wxzx.0ef5d995.png";